import React, { useState } from 'react';
import { Checkbox, LinkButton, Typography } from 'fronton-react';
import { ChooseKeycardWrapper, KeycardChooseLinkButton, MarketingConsentCheckboxWrapper } from './styles';
import { Keycard } from './keycard';
import { EKeycardType } from 'reducers/loyalty-registration-modal-reducer';
import { sendChooseCardEvent, sendGetPromoCheckboxEvent } from 'utils/ga-events';
import { Trans, useTranslation } from 'react-i18next';
import { patchUrlByLocale } from '../../../utils';
import { useStoreon } from 'storeon/react';
import { State } from '../../../store/types';

interface IChooseKeycardProps {
  fetchPhoneVerify: (keycardType: EKeycardType, marketingConsent: boolean) => void;
  setKeycardTypeAndMarketingConsent: (keycardType: EKeycardType, marketingConsent: boolean) => void;
}

export const ChooseKeycard: React.FC<IChooseKeycardProps> = ({
  fetchPhoneVerify,
  setKeycardTypeAndMarketingConsent,
}) => {
  const {
    cookies: { lang },
    path: { pathname },
  } = useStoreon<State>('cookies', 'path');
  const { t } = useTranslation();

  const [marketingConsent, setMarketingContest] = useState<boolean>(true);

  const handleChange = (keycardType: EKeycardType) => {
    setKeycardTypeAndMarketingConsent(keycardType, marketingConsent);
    fetchPhoneVerify(keycardType, marketingConsent);
    sendChooseCardEvent(keycardType);
  };

  const handleCheckbox = (value: boolean) => {
    setMarketingContest(value);
    sendGetPromoCheckboxEvent(value);
  };

  return (
    <>
      <ChooseKeycardWrapper>
        <Keycard
          title={t('loyalty-registration-modal.choose-keycard-step.keycard-home')}
          label={t('loyalty-registration-modal.choose-keycard-step.for-repair')}
          onCreate={() => handleChange(EKeycardType.HOME)}
        />
        <Keycard
          title={t('loyalty-registration-modal.choose-keycard-step.keycard-pro')}
          label={t('loyalty-registration-modal.choose-keycard-step.for-builders')}
          pro
          onCreate={() => handleChange(EKeycardType.PRO)}
        />
      </ChooseKeycardWrapper>
      <Typography variant="s" size="body_short" color="text-secondary">
        <Trans
          i18nKey="loyalty-registration-modal.choose-keycard-step.agreements"
          components={{
            KeycardHomeLink: (
              <KeycardChooseLinkButton
                as="a"
                target="_blank"
                href="https://storage.yandexcloud.net/lmru-loyalty-documents/ru/keycard-for-home-rules.pdf"
              />
            ),
            KeycardProLink: (
              <KeycardChooseLinkButton
                as="a"
                target="_blank"
                href="https://storage.yandexcloud.net/lmru-loyalty-documents/ru/keycard-pro-rules.pdf"
              />
            ),
          }}
        />
      </Typography>
      <MarketingConsentCheckboxWrapper>
        {/* @ts-expect-error - TODO: NAVI-5594 */}
        <Checkbox
          data-qa="marketing-consent"
          checked={marketingConsent}
          onChange={handleCheckbox}
          label={
            <Trans
              i18nKey="loyalty-registration-modal.choose-keycard-step.want-reveice-promo"
              components={{
                advertisingLink: (
                  <LinkButton
                    size="s"
                    variant="underline"
                    href={patchUrlByLocale({
                      url: '/legal/soglasie-na-poluchenie-reklamy/',
                      pathname,
                      lang,
                    })}
                    target="_blank"
                  />
                ),
              }}
            />
          }
          withExtraClickZone={false}
          size="m"
        />
      </MarketingConsentCheckboxWrapper>
    </>
  );
};
